import React from "react";
import styled from "styled-components";

import Header from "../components/Header/Header";
import Footer from "../components/Footer";
import TopNotice from "../components/TopNotice";

const ContentWrapper = styled.main`
  /* adjust based on header height */
  background-color: #000;
  color: #fff;
`;

const Layout = ({ children }) => {
  return (
    <>
      {/* <TopNotice /> */}
      <Header />
      <ContentWrapper>{children}</ContentWrapper>
      <Footer />
    </>
  );
};

export default Layout;
